export default __webpack_public_path__ + "static/media/bs-coat-of-arms.aca2c3d8.svg";